// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins
class CollectionCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide', 'next', 'previous']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) return
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        defaultAnimation: {
          duration: config.defaultAnimation.duration,
        },
        dragSpeed: config.dragSpeed,
        slides: {
          perView: 'auto',
          spacing: 10,
        },
        breakpoints: {
          '(max-width: 767px)': {
            slides: {
              perView: 'auto',
              spacing: 10,
            },
          },
          '(min-width: 768px)': {
            slides: {
              perView: 'auto',
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 'auto',
              spacing: 30,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          previous: this.els.previous.element,
          next: this.els.next.element,
        }),
      ],
    )
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel)
}
